import { GetBlogActiveCards } from "@/types/BlogsType";
import axios from "axios";

const http = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  timeout: 10000,
});

export function getBlogActiveCards({
  id,
  documentGroupId,
  skip,
  take,
  isActive,
  selected,
  mostVisited,
}: GetBlogActiveCards) {
  return http
    .post(`/DocumentApi/GetSelectedDocumentsCards`, {
      id,
      documentGroupId,
      skip,
      take,
      isActive,
      selected,
      mostVisited,
    })
    .then(({ data }) => data);
}
